<template>
  <div class="app-container">
    <div class="order-btn">
      <vxe-button @click="returnFun()">返回</vxe-button>
      <!-- <vxe-button status="success" @click="approveFun()">通过</vxe-button>
      <vxe-button status="danger" @click="rejectFun()">驳回</vxe-button> -->


      <vxe-button v-if="approveBtnType === '3'" status="primary" @click="handleApprove(5)">重新发起审批</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" status="primary" @click="handleApprove(1)">同意</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" status="warning" @click="handleApprove(2)">退回上一审批人</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" status="danger" @click="handleApprove(3)">驳回</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" status="danger" @click="handleApprove(6)">不同意</vxe-button>
      <vxe-button v-if="approveBtnType === '1'" @click="handleApprove(4)">转派</vxe-button>
    </div>
    <a-divider />
    <div class="orderFormLine">订单信息</div>
    <div class="budgetBox">
      <a-form ref="orderForm" class="UniformCss" :inline="true" :model="order" label-width="100px">
        <a-row>
          <a-col :span="4">
            <a-form-item label="订单编号" prop="applyOrderCode">
              <a-input v-model="order.applyOrderCode" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领部门" prop="orgName">
              <a-input v-model="order.orgName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领人" prop="applyMan">
              <a-input v-model="order.applyMan" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="申领日期" prop="applyTime">
              <a-input v-model="order.applyTime" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总项数" prop="orderMaterialCount">
              <a-input v-model="order.orderMaterialCount" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总数量" prop="orderNums">
              <a-input v-model="order.orderNums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="订单总金额" prop="orderTotalSums">
              <a-input v-model="order.orderTotalSums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="审批数量" prop="approveNums">
              <a-input v-model="order.approveNums" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="审批总金额" prop="approveTotalSums">
              <a-input v-model="order.approveTotalSums" :disabled="true" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="领料人" prop="drawMan">
              <a-input v-model="order.drawMan" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="领取用途" prop="drawFor">
              <a-input v-model="order.drawFor" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="领用部门" prop="drawOrz">
              <a-input v-model="order.drawOrz" :disabled="true" />
            </a-form-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-item label="收货人" prop="receiverName">
              <a-input v-model="order.receiverName" :disabled="true" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="收货联系方式" prop="receivePhone">
              <a-input v-model="order.receivePhone" :disabled="true" />
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="收货地区">
              <a-input v-model="order.receiveArea" disabled />
            </a-form-item>
          </a-col> -->
          <a-col :span="4">
            <a-form-item label="详细地址">
              <a-input v-model="order.address" disabled />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- lr0019 -->
        <!-- <a-row>
          <a-col :span="12">
            <a-form-item label="评审意见">
              <a-input v-model="order.approveInfo" />
            </a-form-item>
          </a-col>
        </a-row> -->
      </a-form>
    </div>
    <div class="orderFormLine">物料信息</div>
    <div>
      <vxe-table
        :data="materialList"
        show-header-overflow
        show-overflow
        border
        style="width: 100%"
        :header-cell-style="{background:'#eef1f6'}"
      >
        <vxe-table-column v-if="order.orderStatus == '1'" title="操作" width="100" align="center" fixed="right">
          <template #default="{ row }">
            <a-button primary type="link" @click="editFun('', row)">修改</a-button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="materialCode" title="物料号" width="150" align="center" />
        <vxe-table-column field="materialName" title="物料名称" width="250" align="center" />
        <vxe-table-column field="storage" title="数量" width="90" align="center" />
        <vxe-table-column field="price" title="申领价" width="90" align="center" />
        <vxe-table-column field="nums" title="申领数量" width="90" align="center" />
        <vxe-table-column field="totalSums" title="申领总金额" width="90" align="center" />
        <vxe-table-column field="approveNums" title="审批数量" width="90" align="center" />
        <vxe-table-column field="approveTotalSums" title="审批总金额" width="90" align="center" />
        <vxe-table-column field="applyRemarks" title="申领备注" width="160" :resizable="false" show-overflow align="center" />

        <!-- <vxe-table-column field="approveRemarks" title="审批备注" align="center" /> -->
      </vxe-table>
      <ApproveMaterialDialog :visible.sync="dialogVisible" :orderMaterial.sync="rowMaterial" :pictures="picList" @saveMaterial="saveMaterial" @cancel="cancel" @close="close" />
      <!-- <ApproveMaterialDialog :visible.sync="dialogVisible" :orderMaterial.sync="rowMaterial" :pictures="picList" @saveMaterial="saveMaterial" @cancel="cancel" @close="close" /> -->

    </div>
    <div>
      <el-collapse v-model="collapseNumber" class="collapse-box" style="margin-bottom:10px">
        <el-collapse-item class="collapseItem" title="提报审核历史" name="default">
          <el-table :data="findHistTasksData" :loading="approveLoading" border stripe style="width: 100%">
            <el-table-column prop="displayName" label="审核部门" />
            <el-table-column prop="operatorName" label="审核人" />
            <el-table-column prop="finishTime" label="审核时间" />
            <el-table-column prop="amounts" label="申请费用(元)" align="right">
              <template #default="{ row }">
                <span v-if="row.amounts">
                  {{ row.amounts | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="approveCost" label="审核费用(元)" align="right">
              <template #default="{ row }">
                <span v-if="row.approveCost">
                  {{ row.approveCost | toThousandNumFilter }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="operateType" label="操作类型" />
            <el-table-column prop="approveMsg" label="审核意见" />
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog title="审批信息" :visible.sync="approveDialogVisible" width="40%">
      <div v-if="approveTypeName === '转 派'" class="demo-input-suffix" style="padding-bottom: 20px;">
        转派人：
        <el-input v-model="operatorUser" placeholder="请选择转派的用户" style="width:35%" @focus="chooseUser" />
      </div>
      <div v-if="approveTypeName === '同 意' && order.isDealer != '1'" class="demo-input-suffix" style="padding-bottom: 20px;">
        <div style="margin-bottom: 10px;">
          年度申领额度（元）：
          <a-input :value="order.yearApplyQuota || 0" :disabled="true" style="width: 200px;" />
        </div>
        <div style="margin-bottom: 10px;">
          年度累计申领金额（元）：
          <a-input :value="order.yearTotalAmount || 0" :disabled="true" style="width: 200px;" />
        </div>
      </div>
      <!-- <div v-if="approveTypeName === '同 意'" class="demo-input-suffix" style="padding-bottom: 20px;">
        审核金额：
        <el-input-number v-model="approveCost" :precision="2" controls-position="right" :step="0.1" :min="0.00" :max="9000000000000" :controls="false" />
      </div> -->
      <el-input
        v-model="approveMsg"
        @input="gettotalCost"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <span v-if="approveValFalse" style="color:red">审批意见不能为空</span>
      <span slot="footer" class="dialog-footer">
        <vxe-button :loading="approveBtnLoading" type="primary" @click="approve()">{{ approveTypeName }}</vxe-button>
        <vxe-button @click="cancelDialogVisible">取 消</vxe-button>
      </span>
    </el-dialog>
    <el-dialog title="选择用户" :visible.sync="userDialogVisible" width="75%">
      <div style="margin-bottom: 20px">
        <el-input v-model="userName" placeholder="输入用户名称" clearable :style="{ width: '80%' }" @change="handleFilter" />
        <vxe-button type="primary" icon="el-icon-search" class="filter-search-item" style="float: right" @click="handleFilter">查询</vxe-button>
      </div>
      <vxe-table
        ref="Xuser"
        border
        show-header-overflow
        show-overflow
        :column-config="{ resizable: true }"
        stripe
        round
        :loading="userLoading"
        max-height="350"
        align="center"
        :scroll-y="{ enabled: false }"
        :data="userLists"
        :reserve="true"
        :row-config="{ isCurrent: true, isHover: true }"
        :radio-config="{ strict: false, labelField: 'seq', trigger: 'row', isCurrent: true, isHover: true }"
      >
        <vxe-column type="radio" width="60" />
        <vxe-column :visible="false" field="id" title="用户id" />
        <vxe-column type="seq" title="序号" width="60" />
        <vxe-column field="name" title="用户名称" width="110" />
        <!-- <vxe-column field="roleNames" title="角色" /> -->
        <vxe-column field="department" title="所属组织结构" />
      </vxe-table>
      <vxe-pager
        :loading="userLoading"
        :current-page="addTablePage.currentPage"
        :page-size="addTablePage.pageSize"
        :total="addTablePage.totalResult"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="handlePageChange"
      />
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="userDialogVisible = false">取 消</vxe-button>
        <vxe-button type="primary" @click="handleChooseUser()">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderById, findList4MaterialApply, approveOrder, rejectOrder, saveOrderMaterial, getMaterialById, getMaterialApplyProcessCode,getImgs,findAddressListAll } from '@/api/material'
import ApproveMaterialDialog from './components/ApproveMaterialDialog.vue'
import { approveStart, approveExecute, executeLastNode, executeAndJumpFirst, transfer, approveRestart, findTaskInfos, findDisTaskInfos} from '@/api/wf_process.js'
import { saveApplyOrderInfo, updateOrderStatus } from '@/api/actPlan.js'
import { findList } from '@/api/user'
import { dateFormat } from '@/utils/DateUtils'
import { mapGetters } from 'vuex'
import { setInitImg } from '@/utils/Picture/transferFile'


const defaultApproveType = new Map([
  [0, '发起审批'],
  [1, '同 意'],
  [2, '退回上一审批人'],
  [3, '驳 回'],
  [4, '转 派'],
  [5, '重新发起审批'],
  [6, '不同意']
])


const defaultListQuery = {
  page: 1,
  limit: 10,
  importance: undefined,
  domain: 'center',
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}
const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}
export default {
  name: 'ApplyOrderApprove',
  components: {
    ApproveMaterialDialog
  },
  data() {
    return {
      order: {},
      receiveAddressList: [],
      materialList: [],
      findHistTasksData: [],
      collapseNumber: 'default',
      approveLoading: false,
      dialogVisible: false,
      approveDialogVisible: false,
      rowMaterial: {},
      materialIndex: 0,
      picList: [],
      approveCost: '',
      factor: Object.assign({}, defautFactor),
      listQuery: Object.assign({}, defaultListQuery),
      approveType: defaultApproveType,
      userLoading: false,
      approveBtnLoading: false,
      userDialogVisible: false,
      operatorUser: '',
      operatorId: '',
      userName: '',
      approveMsg: '',
      approveValFalse: false,
      approveTypeName: '',
      addTablePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      userLists: [],
      ApplyProCode: '',
      approveBtnType: '0',
    }
  },
  watch: {
    // 这段代码的主要作用是当物料列表(materialList)发生变化时，自动重新计算审批总数量和总金额，并更新到订单(order)对象中。
    materialList: {
      // 定义变化处理函数，newVal是变化后的新值
      handler(newVal) {
        // 初始化审批总金额为0
        let approveTotalSums = 0
        // 初始化审批总数量为0
        let approveNums = 0
        for (let i = 0; i < newVal.length; i++) {
          // 累加每个物料的审批数量
          approveNums += Number(newVal[i].approveNums)
          // 计算单个物料的审批金额(单价×数量)，保留10位小数
          newVal[i].approveTotalSums = Number((newVal[i].price * newVal[i].approveNums).toFixed(10))
          // 累加每个物料的审批金额
          approveTotalSums = Number((approveTotalSums + newVal[i].approveTotalSums).toFixed(10))
        }
        this.order.approveNums = approveNums
        this.order.approveTotalSums = approveTotalSums
      },
      // 启用深度监听，可以检测数组内部元素变化
      deep: true
    }
  },
  computed: {
    ...mapGetters('account', ['user']),
  },
  created() {
    if (this.$route.params.id) {
      this.order.id = this.$route.params.id
      this.findAddressListAll()
      this.getData()
      this.getMaterialApplyProcessCode()
    }
  },
  methods: {
    async findAddressListAll() {
      const params = {
      }
      await findAddressListAll(params).then(res => {
        this.receiveAddressList = Array.isArray(res.data) ? res.data : []
        // 地址簿到位后立即尝试映射姓名
        this.ensureReceiverName()
      })
    },

       ensureReceiverName() {
      if (!this.order) return
      const rKey = this.order._receiverKey
      // const rKey = this.order.receiveId || this.order.receiver || this.order._receiverKey

      if (!rKey) return
      // 1) 后端直接给的姓名（标准字段）
      if (this.order.receiverName) return

      // 2) 地址簿映射
      if (Array.isArray(this.receiveAddressList) && this.receiveAddressList.length) {
        const hit = this.receiveAddressList.find(it => String(it.id) === String(rKey))
        if (hit && hit.recipientName) {
          this.order.receiverName = hit.recipientName
          return
        }
      }
    },

    async getData() {
      await getOrderById(this.order.id).then(async res => {
        if (res.code === 1) {
          this.order = res.data
          // this.order = res.data || this.order
      console.log(this.order,'this.order1');
      console.log(res.data.receiverName, 'this.order1.receiverName after mapped')

      if (res.data && res.data.receiverName) this.order.receiverName = res.data.receiverName
      this.order._receiverKey = this.order.receiveId || this.order.receiver || ''
      this.ensureReceiverName()
      this.$nextTick(() => {
      console.log(this.order.receiverName, 'receiverName after mapped')
      })


          // 优先使用后端姓名
          // this.order.receiverName = res.data.receiverName || ''
          // 如果没有姓名但有ID/账号，尝试查询用户姓名
          // const receiverKey = res.data.receiverId || res.data.receiver
          // if (!this.order.receiverName && receiverKey) {
          //   try {
          //     const factor = { ...this.factor, code: 'idOrAccount', values: receiverKey }
          //     const listQuery = { ...this.listQuery, page: 1, limit: 1, conditions: [factor] }
          //     const uRes = await findList(listQuery)
          //     if (uRes && uRes.code === 1 && uRes.data && uRes.data.list && uRes.data.list.length) {
          //       this.order.receiverName = uRes.data.list[0].name || ''
          //     } else {
          //       // 查询不到姓名则不显示数字ID
          //       this.order.receiverName = ''
          //     }
          //   } catch (e) {
          //     this.order.receiverName = ''
          //   }
          // }
          // 订单状态判断按钮
          this.handleAppBtn()
          // 拿到审核流程
          this.viewApproveDetail()
        } else {
          this.$message.error(res.message)
        }
      })

      await findList4MaterialApply({ orderId: this.order.id }).then(res => {
        if (res.code === 1) {
          this.materialList = res.data.list
          this.materialList.forEach(item => {
            if (item.approveNums === 0 && this.order.orderStatus === '0') {
              item.approveNums = item.nums
              item.approveTotalSums = item.totalSums
            }
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
          // 拿到审核流程
    viewApproveDetail() {
      const param = {
        orderId: this.order.applyOrderId
        // orderId: 'c3dd1125e8bb4f7b99a1e33aa52c679a'
      }
      this.approveLoading = true
      if (this.order.orderStatus === '3') {
        findDisTaskInfos(param).then(res => {
          this.findHistTasksData = res.data
          this.fillAuditorNameIfEmpty()
          this.approveLoading = false
        })
      } else {
        findTaskInfos(param).then(res => {
          if (res.code === 1 && res.data) {
            this.findHistTasksData = res.data
            // this.findHistTasksData.forEach(item => {
            //   if (!item.his) {
            //     item.operatorName = this.signData.applyAuditorNames
            //     item.finishTime = '正在处理'
            //   }
            // })
            this.fillAuditorNameIfEmpty();
            this.approveLoading = false
          }
        })
      }
    },
    returnFun() {
      this.returnListFun()
    },


    // 修改
    editFun(index, row) {
      this.dialogVisible = true
      this.rowMaterial = row

       // 清空之前的数据+
      this.fileNames = [];
      this.picList = [];

      getMaterialById(row.materialId).then(res => {
        if (res.code === 1) {
          this.material = res.data.material
          if (res.data.fileNames.length > 0) {
            this.fileNames = res.data.fileNames
            // this.inItImages()
            this.inItImages(row); // 确保传入row参数+
          }
        } else {
          this.$message.error(res.message)
        }
        this.saveLoad = false
      })
    },

    inItImages(row) {
  if (!this.fileNames || this.fileNames.length === 0)
      return;
  // 临时数组存储新图片
  const newPics = [];
  this.fileNames.forEach(name => {
    const data = {
      fileName: name,
      materialCode: row.materialCode // 使用当前行的materialCode
    }
    getImgs(data).then(res => {
      const file = setInitImg(res, name)
      // 检查是否已存在
      if (!this.picList.some(p => p.name === file.name)) {
        newPics.push(file);
      }
      // 当所有图片处理完成
      if (newPics.length === this.fileNames.length) {
        this.picList = [...newPics]; // 替换整个数组
      }
      this.saveLoad = false;
    })
  })
  },
    // inItImages() {
    //       // 遍历组件中的fileNames数组，对每个文件名执行回调函数
    //   this.fileNames.forEach(name => {
    //     const data = {
    //       fileName: name,
    //       materialCode: this.materialList[0].materialCode
    //       // materialCode: this.materialList.length > 0 ? this.materialList[0].materialCode : ''
    //     }
    //     getImgs(data).then(res => {
    //       const file = setInitImg(res, name)
    //       // this.picList.push(file)  下面保证不重复
    //       this.picList.push(file)
    //       this.saveLoad = false
    //     })
    //   })
    // },

  //   inItImages(row) {
  // if (!this.fileNames || this.fileNames.length === 0) return;

  // this.fileNames.forEach(name => {
  //   const data = {
  //     fileName: name,
  //     materialCode: row.materialCode // 使用传入row的materialCode
  //   };

  //   getImgs(data).then(res => {
  //     const file = setInitImg(res, name);
  //     if (!this.picList.some(item => item.name === file.name)) {
  //       this.picList.push(file);
  //     }
  //     this.saveLoad = false;
  //   }).catch(error => {
  //     console.error('获取图片失败:', error);
  //     this.saveLoad = false;
  //   })})},
          // if(res.data.fileNames.length > 0){
          //  let arrData =  res.data.fileNames.map(item =>{
          //     return url + '/' + item
          //   })
          //   this.picList = arrData
          // }

    // 审核 未启用
    approveFun() {
      const data = {
        order: this.order,
        list: this.materialList
      }
      approveOrder(data).then(res => {
        if (res.code === 1) {
          this.$message.success('审核通过')
          this.returnListFun()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 驳回 未启用
    rejectFun() {
      this.$confirm({
        title: '确定驳回该订单？',
        content: '',
        onOk:() => {
          rejectOrder(this.order).then(res => {
            if (res.code === 1) {
              this.$message.success('已驳回')
              this.returnListFun()
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel() {},
      });
    },

    // 父传子保存物料
    saveMaterial(data) {
      saveOrderMaterial([data]).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
          this.dialogVisible = false
        } else {
          this.$message.error('保存失败')
        }
      })
    },

    cancel() {
      this.dialogVisible = false
    },


    close() {
      this.dialogVisible = false
      this.getData()
    },

    returnListFun() {
      if(this.$route.query.type === 'myToDolistGuangXuan'){
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderDetail', '/publicizeMaterialManagement/myToDolist')
      }else {
        // 跳转路由
        this.$closePage('/publicizeMaterialManagement/applyOrderApprove', '/publicizeMaterialManagement/AdvertiseMaterialRequisition')
      }
    },

    // 转派
    handleChooseUser() {
      const data = this.$refs['Xuser'].getRadioRecord()
      if (data) {
        this.operatorUser = data.name
        this.operatorId = data.id
      }
      this.userDialogVisible = false
    },

    handlePageChange({ currentPage, pageSize }) {
      this.addTablePage.currentPage = currentPage
      this.addTablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.findUsers()
    },

    handleFilter() {
      this.listQuery.page = 1
      this.factor.code = 'nameOrAccount'
      this.factor.values = this.userName
      this.listQuery.conditions[0] = this.factor
      this.findUsers()
    },

    chooseUser() {
      this.userDialogVisible = true
      this.findUsers()
    },

    findUsers() {
      this.userLoading = true
      findList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.userLists = res.data.list
          this.addTablePage.totalResult = res.data.total
          this.userLoading = false
        }
      })
    },
    gettotalCost() {
      if(this.approveTypeName === '退回上一审批人' ||
      this.approveTypeName === '驳 回' ||
      this.approveTypeName === '不同意') {
        if(this.approveMsg){
          this.approveValFalse = false
        } else {
          this.approveValFalse = true
        }
      }
    },
    handleApprove(type) {
      this.approveMsg = ''
      this.approveTypeName = this.approveType.get(type)
      this.approveDialogVisible = true
      this.approveBtnLoading = false
      this.approveValFalse = false
    },

    approve() {
      //  发起审批
      this.approveBtnLoading = true
      // if (this.approveTypeName === '发起审批') {
      //   this.approveStartFun()
      // }
      if (this.approveTypeName === '同 意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          // 设置审批单ID
          orderId: this.order.applyOrderId,
          // 设置流程名称
          processName: this.order.processName,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType:"同意"
            // S-ACTOR:""
          }
        }
        approveExecute(approveParam).then(res => {
          console.log(res.data.endFlg,'---endFlg---');
          let params = {};
          this.approveBtnLoading = false
            if (res.code === 1) {
              // 判断是否是最终审批！！
              if (res.data.endFlg === true) {
                // 最终审批：除保存审批信息外，触发核销保存
                // 开始构建最终审批参数
                params = {
                  id: this.order.id,
                  applyOrderId: res.data.orderId,
                  // applyAuditorNames: res.data.operatorInfos[0].operatorNames,
                  // applyAuditorIds: res.data.operatorInfos[0].operatorIds,
                  // 设置订单状态为已审批
                  orderStatus : '2'
                }
                // 如果不是最终审批 开始构建普通审批参数
              } else {
                params = {
                  id: this.order.id,
                  applyOrderId: res.data.orderId,
                  // 设置审批人姓名
                  applyAuditorNames: res.data.operatorInfos[0].operatorNames,
                  // 设置审批人ID
                  applyAuditorIds: res.data.operatorInfos[0].operatorIds,
                }
              }
              // 调用保存申请单信息接口
              saveApplyOrderInfo(params).then(v => {
                if (v.code === 1) {
                  // 关闭审批对话框
                  this.approveDialogVisible = false
                  this.returnListFun()
                }
              })
            }else {
              this.$message.error(res.message)
              this.approveDialogVisible = false  // 关闭审批弹框
            }
        })
      }
      // 退回上一步
      if (this.approveTypeName === '退回上一审批人') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.order.applyOrderId,
          processName: this.order.processName,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType:"退回上一审批人"
            // S-ACTOR:""
          }
        }
        executeLastNode(approveParam).then(res => {
          this.approveBtnLoading = false
          // if (res.code === 1) {
            // this.approveDialogVisible = false  // 关闭审批弹框
            // this.returnListFun()
            if (res.code === 1) {
              let params = {
                id: this.order.id,
                applyOrderId: res.data.orderId,
                applyAuditorNames: res.data.operatorInfos[0].operatorNames,
                applyAuditorIds: res.data.operatorInfos[0].operatorIds,
                // applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
                // processName: obj.value
              }
              saveApplyOrderInfo(params).then(v => {
                if (v.code === 1) {
                  this.approveDialogVisible = false
                  this.returnListFun()
                }
              })
            }else {
              this.$message.error(res.message)
              this.approveDialogVisible = false  // 关闭审批弹框
            }
          // }
        })
      }
      // 驳回
      if (this.approveTypeName === '驳 回') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          orderId: this.order.applyOrderId,
          processName: this.order.processName,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType:"驳回"
            // S-ACTOR:""
          }
        }
        executeAndJumpFirst(approveParam).then(res => {
          this.approveBtnLoading = false
          // if (res.code === 1) {
            // this.approveDialogVisible = false  // 关闭审批弹框
            // this.returnListFun()
            if (res.code === 1) {
              let params = {
                id: this.order.id,
                applyOrderId: res.data.orderId,
                applyAuditorNames: res.data.operatorInfos[0].operatorNames,
                applyAuditorIds: res.data.operatorInfos[0].operatorIds,
                orderStatus : '3'
                // applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
                // processName: obj.value
              }
              saveApplyOrderInfo(params).then(v => {
                if (v.code === 1) {
                  this.approveDialogVisible = false
                  this.returnListFun()
                }
              })
            }else {
              this.$message.error(res.message)
              this.approveDialogVisible = false  // 关闭审批弹框
            }
          // }
        })
      }
      // 转派
      if (this.approveTypeName === '转 派') {
        const approveParam = {
          orderId: this.order.applyOrderId,
          processName: this.order.processName,
          operator: this.operatorId,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType:"转派"
            // S-ACTOR:""
          }
        }
        transfer(approveParam).then(res => {
          this.approveBtnLoading = false
          // if (res.code === 1) {
            // this.approveDialogVisible = false  // 关闭审批弹框
            // this.returnListFun()
            if (res.code === 1) {
              let params = {
                id: this.order.id,
                applyOrderId: res.data.orderId,
                applyAuditorNames: res.data.operatorInfos[0].operatorNames,
                applyAuditorIds: res.data.operatorInfos[0].operatorIds,
                // applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
                // processName: obj.value
              }
              saveApplyOrderInfo(params).then(v => {
                if (v.code === 1) {
                  this.approveDialogVisible = false
                  this.returnListFun()
                }
              })
            }else {
              this.$message.error(res.message)
              this.approveDialogVisible = false  // 关闭审批弹框
            }
          // }
        })
      }
      // 不同意
      if (this.approveTypeName === '不同意') {
        if (this.approveMsg === '') {
          this.approveBtnLoading = false
          // this.$message.warning('审批意见不能为空')
          this.approveValFalse = true
          return
        }
        const approveParam = {
          disagree: '1',
          orderId: this.order.applyOrderId,
          processName: this.order.processName,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType:"不同意"
            // S-ACTOR:""
          }
        }
        approveExecute(approveParam).then(res => {
          this.approveBtnLoading = false
          // if (res.code === 1) {
            // this.approveDialogVisible = false  // 关闭审批弹框
            // this.returnListFun()
            if (res.code === 1) {
              let params = {
                id: this.order.id,
                applyOrderId: res.data.orderId,
                applyAuditorNames: this.order.applyAuditorNames,
                applyAuditorIds: this.order.applyAuditorIds,
                orderStatus : '6'
                // applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
                // processName: obj.value
              }
              saveApplyOrderInfo(params).then(v => {
                if (v.code === 1) {
                  this.approveDialogVisible = false
                  this.returnListFun()
                }
              })
            }else {
              this.$message.error(res.message)
              this.approveDialogVisible = false  // 关闭审批弹框
            }
          // }
        })
      }
      // 驳回后重新发起流程
      if (this.approveTypeName === '重新发起审批') {
        this.approveRestartFun()
      }

    },
    cancelDialogVisible() {
      this.approveDialogVisible = false
    },

    // 获取物料申领流程的流程编码
    getMaterialApplyProcessCode() {
      getMaterialApplyProcessCode().then(res => {
          if (res.code === 1) {
            this.ApplyProCode = res.data
            console.log(res,'------获取物料申领流程的流程编码------');
          }
        })
    },

    // saveApplyOrderInfo, 未启用
    approveStartFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['materialApplyProcessMap']).then(v => {
        // const obj = v.materialApplyProcessMap.find(item => item.code === this.activity.budgetTypeCode)
        const obj = v.materialApplyProcessMap.find(item => item.code == this.ApplyProCode)
        console.log(obj,'----obj');
        const approveParam = {
          processName: obj.value,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType: '发起审批'
            // S-ACTOR:""
          }
        }
        approveStart(approveParam).then(res => {
          if (res.code === 1) {
            let params = {
              id: this.order.id,
              applyOrderId: res.data.orderId,
              applyAuditorNames: res.data.operatorInfos[0].operatorNames,
              applyAuditorIds: res.data.operatorInfos[0].operatorIds,
              applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
            }
            saveApplyOrderInfo(params).then(v => {
              if (v.code === 1) {
                this.approveBtnLoading = false
                this.approveDialogVisible = false  // 关闭审批弹框
                this.returnListFun()
              }
            })
          }
        })
      })
    },

    // 重新发起
    approveRestartFun() {

      updateOrderStatus(this.order.id).then(v => {
        if (v.code === 1) {
          console.log(v);
        }
      })

      const approveParam = {
        orderId: this.order.applyOrderId,
        processName: this.order.processName,
        args: {
          applyOrderCode:this.order.applyOrderCode,
          orderNums:this.order.orderNums,
          approveMsg: this.approveMsg,
          orderTotalSums:this.order.orderTotalSums,
          drawMan:this.order.drawMan,
          drawFor:this.order.drawFor,
          operateType:"重新发起审批"
          // S-ACTOR:""
        }
      }
      this.approveBtnLoading = true
      approveRestart(approveParam).then(res => {
        this.approveBtnLoading = false
        if (res.code === 1) {
          // this.approveDialogVisible = false  // 关闭审批弹框
          // this.returnListFun()

          let params = {
              id: this.order.id,
              applyOrderId: res.data.orderId,
              applyAuditorNames: res.data.operatorInfos[0].operatorNames,
              applyAuditorIds: res.data.operatorInfos[0].operatorIds,
              applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
            }
            saveApplyOrderInfo(params).then(v => {
              if (v.code === 1) {
                this.approveBtnLoading = false
                this.approveDialogVisible = false  // 关闭审批弹框
                this.returnListFun()
              }
            })
        }else {
          this.$message.error(res.message)
          this.approveDialogVisible = false  // 关闭审批弹框
        }
      })
    },

    handleAppBtn() {
      // 订单状态:0录入中,1审核中,2审核通过,3已驳回,4部分收货,5已收货,6不通过
      if (this.order.orderStatus === '1' && this.order.applyAuditorIds.indexOf(this.user.userId) !== -1) {
        // 审核中，并且当前用户是审批人，显示同意、退给上一审批人、驳回、不同意和转派
        this.approveBtnType = '1'
      }
      if (this.order.orderStatus === '3' && this.user.userId == this.order.applyAuditorIds) {
        //已驳回，显示重新发起审批
        this.approveBtnType = '3'
      }
    },

    fillAuditorNameIfEmpty() {
      if (!Array.isArray(this.findHistTasksData)) return;

      this.findHistTasksData.forEach(item => {
        // 如果审核部门不为空但审核人为空，且订单中有审核人信息
        if (item.displayName && !item.operatorName && this.order.applyAuditorNames) {
          item.operatorName = this.order.applyAuditorNames;
          item.finishTime = '正在处理';
        }
      });
    }




  }
}
</script>
<style lang="less" scoped>
.orderFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.order-btn {
  margin-top: 0px;
}
.collapseItem {
  /deep/ .el-collapse-item__header {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  /deep/ .el-collapse-item__content {
    padding-top: 20px;
    padding-right: 20px;
  }
}
.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 5px 0;
}
</style>
